/// One-line explanation of what the mode the two flags select actually does, shown live on the
/// create form. Mirrors the backend: TracksQuantity = isPrepaid || clientSuppliedStock;
/// PricesPerOrder = !isPrepaid.
export function describeMode(isPrepaid: boolean, clientSuppliedStock: boolean): string {
  const draws = isPrepaid || clientSuppliedStock;
  const priced = !isPrepaid;
  const drawPart = draws ? "Draws down the balance" : "Does not draw down a balance";
  const pricePart = priced
    ? "orders are priced per order"
    : "orders are not priced — billed when the credits were purchased";
  return `${drawPart}; ${pricePart}.`;
}
